import { NgModule } from '@angular/core';

import { ReportApiService } from './report.service';

@NgModule({
    providers: [ ReportApiService ],
})
export class ReportsApiModule {}
